// extracted by mini-css-extract-plugin
export default {"dropdownSelected":"style_dropdownSelected__PXr2A"};